/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRetail = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 4a3 3 0 0 1 3 3v.5H9V7a3 3 0 0 1 3-3zm5 3.5V7A5 5 0 0 0 7 7v.5H4.113L2.373 22h19.254l-1.74-14.5H17zm-11.113 2h12.226l1.26 10.5H4.627l1.26-10.5zM7 13v-2h2v2H7zm8 0v-2h2v2h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRetail as Retail };
